import { Button } from "alurkerja-ui";
import React, { PropsWithChildren } from "react";
import { Link as ReactLink, To } from "react-router-dom";

interface LinkButtonProps extends PropsWithChildren {
  path?: To;
  onClick?: () => void;
  icon?: React.ReactNode;
  className?: string;
};

export const LinkButton: React.FC<LinkButtonProps> = ({
  path,
  onClick,
  icon,
  className = "",
  children,
}) => {
  if (path) {
    return (
      <ReactLink to={path}>
        <Button className={className}>
          {icon}
          {children}
        </Button>
      </ReactLink>
    );
  }
  return (
    <button type="button" onClick={onClick} className={`button-class ${className}`}>
      {icon}
      {children}
    </button>
  );
};
